module.exports = __webpack_public_path__ + "static/media/arrow-right.d71cd07c.svg";